import React, {useMemo, useRef, useState} from "react";
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Checkbox, InputNumber, Select, Table} from "antd";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import UserImageCircle from "../../../components/UserImageCircle";
import SearchTalentInput from "../../../components/form/SearchTalentInput";
import User from "../../../models/User";
import UserDiscipline from "../../../models/UserDiscipline";
import SpinLoader from "../../../components/SpinLoader";
import {useAuth} from "../../../providers/AuthProvider";
import ReactDOM from "react-dom";
import AnimatedCount from "../../../components/AnimatedCount";

const TeamDisciplineAssignmentForm = ({discipline, onClose = () => true, onCancel = () => true, ...props}) => {

    const {
        team,
        project,
        updateTeamScope,
        isLoading,
        isDisabled,
        updateDisciplineAssignmentForTeamMember
    } = useTeamCandidateScope();

    const {auth} = useAuth();
    const forAgency = team.type === 'Agency';

    const getUserOption = (user) => {
        const userDiscipline = TB.find(user.disciplines || [], ['discipline_id', discipline.id])
        let option = {
            value: user.id,
            user: user,
            title: user.fullName(),
            label: (
                <span className="flex flex-row items-center gap-2">
                    <UserImageCircle user={user} size={28}/>
                    <span>
                        {user.fullName()}
                    </span>

                    {userDiscipline && (
                        <span className="ml-auto">
                            <span className="text-info">{discipline.name}:</span>
                            &nbsp;
                            <span className="font-medium">
                                {TB.formatCurrency(userDiscipline?.hourly_rate)}/hr
                            </span>
                        </span>
                    )}
                </span>
            )
        };
        if (!userDiscipline) {
            option.disabled = false;
            option.label = (
                <div className="items-center flex flex-row whitespace-nowrap">
                    <span>{user.fullName()}</span>
                    <i className="ml-2 text-xxs text-danger">
                        Missing Discipline
                    </i>
                </div>
            )
        }
        return option;
    }

    const defaultMemberOptions = useMemo(() => {
        return TB.reduce(team?.positions || [], (result, value, key) => {

            result.push(getUserOption(value))

            return result
        }, [])
    }, [team?.positions]);

    const formRef = useRef(null);

    const talentOpp = discipline.talent_opp || {};
    const projectDeliverables = TB.flatMap(project.phases, 'deliverables');

    const mapFormModel = (model) => {

        let mapped = {...model};

        let selectedTeamMember = null;
        if (team && mapped.talent_user) {
            selectedTeamMember = TB.find(team.positions, ['id', mapped.talent_user.id]);
        }
        if (!TB.isDefined(mapped.uses_platform_talent_resource)) {
            mapped.uses_platform_talent_resource = !!mapped.talent_user && !selectedTeamMember
        }
        mapped.hourly_rate = parseFloat(mapped.hourly_rate)
        mapped.proposed_hourly_rate = mapped.proposed_hourly_rate ? parseFloat(mapped.proposed_hourly_rate) : undefined;

        mapped.total_hours = TB.sumBy(mapped.deliverable_activities, act => parseInt(act.total_hours || 0));

        // mapped.proposed_total_periods = mapped.proposed_total_periods;
        mapped.payout_amount = Math.ceil(mapped.hourly_rate * mapped.total_hours);

        // mapped.proposed_payout_amount = mapped.proposed_payout_amount || mapped.payout_amount;
        mapped.platform_rate = (parseFloat(mapped.hourly_rate) * parseFloat(mapped.percent_markup)) + parseFloat(mapped.hourly_rate)
        mapped.platform_cost = Math.ceil(parseFloat(mapped.platform_rate) * mapped.total_hours);
        let matchingDisciplineActivities = TB.reduce(TB.flatMap(projectDeliverables, 'activities'), (result, activity) => {
            let matchedDiscipline = TB.find(activity.disciplines, ['id', discipline.id]);
            if (matchedDiscipline) {
                result.push({
                    id: activity.id,
                    description: activity.description,
                    total_hours: 0
                })
            }
            return result
        }, []);

        mapped.deliverable_activities = TB.unionBy([...(mapped.deliverable_activities || [])], matchingDisciplineActivities, 'id');

        return mapped;
    }

    const [formModel, setFormModel] = useState(mapFormModel({
        talent_user: talentOpp.user,
        percent_markup: team?.job_candidate?.percent_markup,
        ...talentOpp.opp_discipline
    }));
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    // console.log('TeamDisciplineAssignmentForm', projectDeliverables)
    const assignedDiscipline = useMemo(() => {
        return TB.find(formModel.talent_user?.disciplines || [], ['discipline_id', discipline.id])
    }, [formModel.talent_user, formModel.uses_platform_talent_resource])


    // console.log('Deliverable', TB.get(scopePhases, TB.split(editingKey, '.activities')[0]))
    // console.log('Phase', TB.get(scopePhases, TB.split(editingKey, '.deliverables')[0]))

    // console.log('TeamDisciplineAssignmentForm', formModel);

    const onChangeResource = (value, option) => {
        if (!formModel.talent_user && !option) {
            return
        }
        // console.log('onChangeResource', option)
        let updates = {
            ...formModel,
            talent_user: option?.user || null,
        }
        if (updates.talent_user) {
            let userDiscipline = TB.find(updates.talent_user?.disciplines || [], ['discipline_id', discipline.id]);
            if (!userDiscipline) {
                userDiscipline = {
                    hourly_rate: UserDiscipline.rateForDiscipline(discipline.id)
                }
            }
            // console.log('onChangeResource', userDiscipline)
            if (userDiscipline) {
                updates = {
                    ...updates,
                    hourly_rate: userDiscipline.hourly_rate,
                    proposed_hourly_rate: undefined,
                    proposed_payout: undefined,
                    deliverable_activities: TB.reduce(TB.flatMap(projectDeliverables, 'activities'), (result, activity) => {
                        let matchedDiscipline = TB.find(activity.disciplines, ['id', discipline.id]);
                        if (matchedDiscipline) {
                            result.push({
                                id: activity.id,
                                description: activity.description,
                                total_hours: matchedDiscipline.total_hours
                            })
                        }
                        return result
                    }, [])
                };
            }
        }
        setFormModel(
            mapFormModel(updates)
        )
    }
    const onSubmit = async () => {
        if (isDisabled) return;


        let invalidFields = await formRef.current?.forceValidate();
        if (invalidFields) {
            const node = ReactDOM.findDOMNode(invalidFields);

            $('.ant-modal-wrap')?.animate({scrollTop: $(node).offset().top}, 1000);
        }
        if (!formModel.talent_user || !formModel.hourly_rate || !formModel.payout_amount) {
            return TB.toast('Form Invalid', {type: 'error'})
        }

        let talent_users = await updateDisciplineAssignmentForTeamMember(discipline.id, formModel);

        let response = await updateTeamScope({talent_users});

        if (response) {
            console.log('onSubmit', response)
            return onClose()
        }
    }

    if (!discipline || !team) return null;

    return (
        <SpinLoader isLoading={isDisabled}>

                <div className="flex flex-col items-stretch">
                    <div className="pb-4 px-6">
                        <Form
                            ref={formRef}
                            onSubmit={onSubmit}
                            minimal
                            submitButton={false}
                            background={"none"}
                            isDisabled={isDisabled}
                            model={formModel}
                            onChange={async (model) => {
                                let updatedFormModel = {...formModel};

                                for (let [key, value] of Object.entries(model)) {
                                    updatedFormModel = TB.set(updatedFormModel, key, value);
                                }

                                console.log('onchange', mapFormModel(updatedFormModel))
                                await setFormModel(mapFormModel(updatedFormModel))
                            }}
                            fields={[]}
                        >

                        <div className="flex gap-4">

                            <div className="w-full">
                                <div className="flex gap-4 pb-2 border-b border-wripplePrimaryRuleBlue mb-4">
                                    <div className="basis-1/2 flex flex-row gap-4 p-3">
                                        <div className="flex-1 flex flex-col gap-2">
                                            <p className="text-sm font-medium text-left">
                                                Assigned Team Member
                                            </p>

                                            {formModel.talent_user?.id ? (
                                                <div className="flex flex-row items-center gap-4">
                                                    <UserImageCircle user={formModel.talent_user} size={80}/>

                                                    <div className="flex flex-col items-start justify-center gap-1.5">
                                                        <p className="font-medium">
                                                            {formModel.talent_user.fullName()}
                                                        </p>

                                                        {assignedDiscipline?.hourly_rate && (
                                                            <p className="text-xs">
                                                                <span className="text-info">{discipline.name}:</span>
                                                                &nbsp;
                                                                <span className="font-medium">
                                                                    Avg
                                                                    Rate {TB.formatCurrency(assignedDiscipline?.hourly_rate)}/hr
                                                                </span>
                                                                &nbsp;
                                                                <i>(from profile)</i>
                                                            </p>
                                                        )}

                                                        <button type="button" onClick={async () => {
                                                            await setFormModel(mapFormModel({
                                                                ...formModel,
                                                                talent_user: null
                                                            }))
                                                            return TB.queryClient.invalidateQueries(['searchCandidates'])
                                                        }} className="btn btn-danger text-xs py-1 px-2">
                                                            Change Resource
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="flex flex-col gap-3">
                                                    <Select
                                                        showArrow
                                                        filterOption={(inputValue, option) => {
                                                            return String(option.label)
                                                                .toLowerCase()
                                                                .includes(String(inputValue).toLowerCase())
                                                        }}
                                                        disabled={formModel.uses_platform_talent_resource}
                                                        placeholder="Select from Team Members"
                                                        value={formModel.talent_user?.id}
                                                        open={isSelectOpen}
                                                        onChange={onChangeResource}
                                                        onDropdownVisibleChange={(visible) => setIsSelectOpen(visible)}
                                                        onSelect={() => setIsSelectOpen(false)}
                                                        onDeselect={() => setIsSelectOpen(false)}
                                                        style={{width: '100%', height: '100%'}}
                                                        options={defaultMemberOptions || []}
                                                    />


                                                    {auth.canManageClients() && (
                                                        <React.Fragment>
                                                            <Checkbox checked={formModel.uses_platform_talent_resource}
                                                                      onChange={e => {
                                                                          setFormModel(mapFormModel({
                                                                              ...formModel,
                                                                              talent_user: null,
                                                                              uses_platform_talent_resource: e.target.checked
                                                                          }))
                                                                      }}>
                                                                Search Talent Members NOT on team
                                                            </Checkbox>

                                                            {formModel.uses_platform_talent_resource && (
                                                                <SearchTalentInput
                                                                    params={{
                                                                        accomplished_disciplines: [discipline.id],
                                                                        // hide_matching: 1,
                                                                        sort_by: 'min_bill_rate'
                                                                    }}
                                                                    perPage={20}
                                                                    onChange={onChangeResource}
                                                                    placeholder="Search for talent users matching this role"
                                                                    isDisabled={isDisabled}
                                                                    inputValue={formModel.talent_user?.id}
                                                                    formatOption={(member) => {
                                                                        let disciplines = member.matching?.disciplines?.disciplines || [
                                                                            {
                                                                                discipline_id: discipline.id, ...discipline,
                                                                                hourly_rate: UserDiscipline.rateForDiscipline(discipline.id)
                                                                            }
                                                                        ]
                                                                        let user = User.make({...member, disciplines})
                                                                        return getUserOption(user)
                                                                    }}
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            )}

                                        </div>

                                    </div>
                                    <div className="basis-1/4 flex flex-row gap-4 p-3">
                                        <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                            <p className="text-sm font-medium text-left">
                                                Talent Rate
                                            </p>

                                            <FormInputComponent
                                                fieldName={`hourly_rate`}
                                                value={formModel?.hourly_rate || ''}
                                                disabled={!formModel.talent_user?.id}
                                                required={true}
                                                label={false}
                                                type="antd-input">

                                                <InputNumber
                                                    controls={false}
                                                    min={1}
                                                    addonBefore="$"
                                                    addonAfter="/hr"
                                                    precision={2}
                                                    defaultValue={talentOpp?.opp_discipline?.hourly_rate || ''}/>

                                            </FormInputComponent>
                                        </div>
                                    </div>
                                    {auth.canManageClients() ? (
                                        <div className="basis-1/4 bg-gray-50 flex flex-row gap-4 self-start p-3">

                                            <div className="flex-1 flex flex-col items-start gap-2">
                                                <p className="text-sm font-medium text-left flex flex-row items-center gap-2">
                                                    Proposed Talent Rate <i className={TB.mapClass("fas", {
                                                    "fa-check-circle text-gray": formModel.proposed_hourly_rate && formModel.proposed_hourly_rate === formModel.hourly_rate,
                                                    "fa-exclamation-triangle text-warning": formModel.proposed_hourly_rate && formModel.proposed_hourly_rate !== formModel.hourly_rate
                                                })}/>
                                                </p>
                                                <p className="h-[30px] leading-[30px] font-medium">
                                                    {formModel?.proposed_hourly_rate ?
                                                        `$${TB.formatNumber(formModel?.proposed_hourly_rate, 2)}/hr` :
                                                        (
                                                            <i className="opacity-50">N/A</i>
                                                        )
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="basis-1/4"/>
                                    )}
                                </div>

                                {/*<div className="flex gap-4 pb-2 mb-4">*/}

                                {/*    */}

                                {/*</div>*/}
                                <div className="flex gap-4 pb-2 mb-4">

                                    <div className="flex-1 flex flex-row gap-4 p-3">

                                        <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                            <p className="text-sm font-medium text-left">
                                                Total Est. Hours
                                            </p>

                                            <AnimatedCount value={formModel?.total_hours}
                                                          className="h-[30px] leading-[30px] font-medium">
                                                {formModel?.total_hours} hours
                                            </AnimatedCount>
                                        </div>

                                    </div>
                                    <div className="flex-1 flex flex-row gap-4 p-3">


                                        <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                            <p className="text-sm font-medium text-left">
                                                Talent Payout
                                            </p>

                                            <AnimatedCount value={formModel?.payout_amount}
                                                          className="h-[30px] leading-[30px] font-medium">
                                                {formModel?.payout_amount ? TB.formatCurrency(formModel?.payout_amount, false) : 'N/A'}
                                            </AnimatedCount>
                                        </div>
                                    </div>
                                    {auth.canManageClients() ? (
                                        <div className="flex-1 bg-gray-50 flex flex-row gap-4 p-3">
                                            <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                                <p className="text-sm font-medium text-left flex flex-row items-center gap-2">
                                                    Proposed Est. Hours <i className={TB.mapClass("fas", {
                                                    "fa-check-circle text-gray": formModel?.proposed_total_periods && formModel.proposed_total_periods === formModel.total_hours,
                                                    "fa-exclamation-triangle text-warning": formModel?.proposed_total_periods && formModel.proposed_total_periods !== formModel.total_hours
                                                })}/>
                                                </p>

                                                <p className="h-[30px] leading-[30px] font-medium">
                                                    {formModel?.proposed_total_periods ? (formModel?.proposed_total_periods + ' hours') : (
                                                        <i className="opacity-50">N/A</i>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex-1"/>
                                    )}
                                    {auth.canManageClients() ? (
                                        <div className="flex-1 bg-gray-50 flex flex-row gap-4 p-3">

                                            <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                                <p className="text-sm font-medium text-left flex flex-row items-center gap-2">
                                                    Proposed Payout <i className={TB.mapClass("fas", {
                                                    "fa-check-circle text-gray": formModel.proposed_payout_amount && formModel.proposed_payout_amount === formModel.payout_amount,
                                                    "fa-exclamation-triangle text-warning": formModel.proposed_payout_amount && formModel.proposed_payout_amount !== formModel.payout_amount
                                                })}/>
                                                </p>

                                                <p className="h-[30px] leading-[30px] font-medium">
                                                    {formModel?.proposed_payout_amount ?
                                                        TB.formatCurrency(formModel?.proposed_payout_amount, false) :
                                                        (
                                                            <i className="opacity-50">N/A</i>
                                                        )
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex-1"/>
                                    )}
                                </div>

                                {auth.canManageClients() && (
                                    <div className="flex gap-4 pb-2 border-b border-wripplePrimaryRuleBlue mb-4">
                                        <div className="flex-1 flex flex-row gap-4 p-3">

                                            <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                                <p className="text-sm font-medium text-left">
                                                    Percent Markup
                                                </p>

                                                <p className="h-[30px] leading-[30px] font-medium">
                                                    {TB.formatNumber((formModel.percent_markup || 0) * 100, 2)}%
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex-1 flex flex-row gap-4 p-3">

                                            <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                                <p className="text-sm font-medium text-left text-info">
                                                    Assigned Bill Rate
                                                </p>

                                                <AnimatedCount value={formModel?.platform_rate}
                                                              className="h-[30px] leading-[30px] font-medium">
                                                    {
                                                        `$${TB.formatNumber(
                                                            formModel.platform_rate,
                                                            2
                                                        )}/hr`
                                                    }
                                                </AnimatedCount>
                                            </div>
                                        </div>
                                        <div className="flex-1 flex flex-row gap-4 p-3">

                                            <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">
                                                <p className="text-sm font-medium text-left text-info">
                                                    Platform Cost
                                                </p>

                                                <AnimatedCount value={formModel.platform_cost}
                                                              className="h-[30px] leading-[30px] font-medium">
                                                    {TB.formatCurrency(formModel.platform_cost, false)}
                                                </AnimatedCount>
                                            </div>

                                        </div>

                                        <div className="flex-1 flex flex-row gap-4 p-3">
                                            <div className="flex-1 max-w-[300px] flex flex-col items-start gap-2">

                                            </div>
                                        </div>

                                    </div>
                                )}

                                <div className="flex flex-col gap-4 pb-2 border-b border-wripplePrimaryRuleBlue mb-4">
                                    <p className="text-base font-semibold">
                                        Estimated Hours By Activity
                                    </p>
                                    <div className="flex-grow px-4">
                                        <Table size="small" pagination={false} rowKey='id'
                                               dataSource={formModel.deliverable_activities}
                                               summary={data => {

                                                   let oppActivityIds = TB.map(data, 'id')
                                                   let matchedProjectDisciplines = TB.filter(
                                                       TB.flatMap(TB.filter(
                                                           TB.flatMap(projectDeliverables, 'activities'),
                                                           act => oppActivityIds.includes(act.id)
                                                       ), 'disciplines'),
                                                       ['id', discipline.id]
                                                   );

                                                   // console.log('matchprojectddd', matchedProjectDisciplines)

                                                   return (
                                                       <Table.Summary.Row>
                                                           <Table.Summary.Cell index={0} className="bg-gray-50">

                                                           </Table.Summary.Cell>
                                                           <Table.Summary.Cell index={1} className="bg-gray-50">
                                                               <p className="font-semibold">
                                                                   Totals
                                                               </p>
                                                           </Table.Summary.Cell>
                                                           <Table.Summary.Cell index={2} className="bg-gray-50">
                                                               <p className="font-semibold">
                                                                   {TB.sumBy(matchedProjectDisciplines, 'total_hours')} hours
                                                               </p>
                                                           </Table.Summary.Cell>
                                                           <Table.Summary.Cell index={2} className="bg-gray-50">
                                                               <p className="font-semibold">
                                                                   {TB.sumBy(data, act => parseInt(act.total_hours || 0))} hours
                                                               </p>
                                                           </Table.Summary.Cell>
                                                       </Table.Summary.Row>
                                                   )
                                               }
                                               }>

                                            <Table.Column title="Deliverable" dataIndex="id" key="id"
                                                          render={(_, activity) => {
                                                              let matchDeliverable = TB.find(projectDeliverables, del => {
                                                                  return TB.find(del.activities, ['id', activity.id])
                                                              })
                                                              return (
                                                                  <p
                                                                      className="text-sm font-medium text-secondary">
                                                                      {matchDeliverable?.name || 'N/A'}
                                                                  </p>
                                                              )
                                                          }}/>
                                            <Table.Column title="Activity" dataIndex="description" key="description"
                                                          render={(description) => (
                                                              <div dangerouslySetInnerHTML={{
                                                                  __html: description || (
                                                                      <i className="opacity-50">No description
                                                                          provided..</i>
                                                                  )
                                                              }}
                                                                   className="w-[350px] text-xs line-clamp-2"/>
                                                          )}/>

                                            <Table.Column title="Original Scoped Hours" dataIndex="id" key="id"
                                                          render={(_, record) => {

                                                              let matchedProjectActivity = TB.find(TB.flatMap(projectDeliverables, 'activities'), ['id', record.id]);

                                                              // console.log('TB.FLATMAP', TB.map(TB.flatMap(projectDeliverables, 'activities'), 'id'), record.id);

                                                              let matchedActivityDiscipline = TB.find(matchedProjectActivity?.disciplines || [], ['id', discipline.id])

                                                              return (
                                                                  <p>
                                                                      {matchedActivityDiscipline?.total_hours ? `${matchedActivityDiscipline.total_hours} hours` : (
                                                                          <i className="opacity-50">-</i>
                                                                      )}
                                                                  </p>
                                                              )
                                                          }}/>

                                            <Table.Column title="Hours" dataIndex="total_hours" key="total_hours"
                                                          render={(total_hours, activity, index) => (
                                                              <div className="w-32">
                                                                  <FormInputComponent
                                                                      fieldName={`deliverable_activities[${index}].total_hours`}
                                                                      value={formModel.deliverable_activities[index]?.total_hours || ''}
                                                                      disabled={!formModel.talent_user?.id}
                                                                      required={true}
                                                                      className="mb-0"
                                                                      label={false}
                                                                      placeholder={'--'}
                                                                      type="antd-input">

                                                                      <InputNumber
                                                                          controls={false}
                                                                          min={1}
                                                                          addonAfter="hrs"
                                                                          precision={0}
                                                                          defaultValue={formModel.deliverable_activities[index]?.total_hours || ''}/>

                                                                  </FormInputComponent>
                                                              </div>
                                                          )}/>

                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </Form>
                </div>

                <div className="flex flex-row items-center justify-end gap-4 px-6 py-4 border border-t-gray-300">

                    <button onClick={() => onCancel()} disabled={isDisabled} className="btn btn-outline-dark">
                        Cancel
                    </button>

                    <button onClick={() => onSubmit()} disabled={isDisabled} className="btn btn-primary">
                        Update
                    </button>
                </div>

            </div>
        </SpinLoader>
    )
}

export default TeamDisciplineAssignmentForm